import { FormControl, Stack } from '@mui/material';
import { TextInput } from '../../MapPage/FacilityFormPage/CommonForm';
import {
  CountingText,
  FormLabelText,
} from '../../../../components/style/TextStyle';
import {
  DepartmentSelect,
  UserRoleSelect,
} from '../../../../components/select/SelectList';

export default function UserInputs({ form }: any) {
  return (
    <>
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        sx={{ w: '100%' }}
        spacing={5}
      >
        <Stack sx={{ flex: 1 }} spacing={1}>
          <TextInput
            form={form}
            isRequired={true}
            label="이메일 주소"
            fieldPath="email"
            placeholder="예시 : Tester@gmail.com"
          />
          <CountingText>
            <span>*</span> 임시 비밀번호를 발송하는 이메일입니다.
          </CountingText>
        </Stack>
        <Stack sx={{ flex: 1 }}>
          <TextInput
            form={form}
            isRequired={true}
            label="연락처"
            fieldPath="phone"
            placeholder="예시 : 01012345678"
          />
        </Stack>
      </Stack>

      <Stack
        direction={{ xs: 'column', md: 'row' }}
        sx={{ w: '100%' }}
        spacing={5}
      >
        <Stack sx={{ flex: 1 }}>
          <TextInput
            form={form}
            isRequired={false}
            label="행정동"
            fieldPath="administrativeRegion"
            placeholder="예시 : 중흥 2동"
          />
        </Stack>
        <Stack sx={{ flex: 1 }}>
          <FormControl sx={{ width: '100%' }}>
            <FormLabelText>소속과</FormLabelText>
            <DepartmentSelect
              department={form.watch('departmentId')}
              onChange={(e: any) =>
                form.setValue('departmentId', e.target.value)
              }
            />
          </FormControl>
        </Stack>
        <Stack sx={{ flex: 1 }}>
          <FormControl sx={{ width: '100%' }}>
            <FormLabelText>권한</FormLabelText>
            <UserRoleSelect
              role={form.watch('role')}
              onChange={(e: any) => form.setValue('role', e.target.value)}
            />
          </FormControl>
        </Stack>
      </Stack>
    </>
  );
}
